import { useState } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { JoinModal } from 'features/paid-membership/JoinModal';
import Button from 'honeydew/Button';
import Card from 'honeydew/Card';
import Tag from 'honeydew/Tag';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';
import useTailwindTheme from 'hooks/useTailwindTheme';

import { BenefitsList } from '../BenefitsList';

export function JoinCard({ paused }) {
    const { availableTrialMembership, plusMembershipBranding } = useAccountPlusMembershipHook();
    const [isJoinMembershipModalOpen, setIsJoinMembershipModalOpen] = useState(false);

    const isTrialAvailable = !!availableTrialMembership;
    const trialLengthDays = availableTrialMembership?.trialDurationDays;
    const heading = paused ? `Save even more with ${plusMembershipBranding}` : `Join ${plusMembershipBranding} Today`;

    const tailwindTheme = useTailwindTheme();
    const mobile = useMediaQuery({ maxWidth: tailwindTheme?.screens?.md });

    const ctaComponent = (
        <Button
            size="md"
            onClick={() => {
                setIsJoinMembershipModalOpen(true);
            }}
            variant="plusMembership"
        >
            {isTrialAvailable ? 'Start free trial today' : `Join ${plusMembershipBranding}`}
        </Button>
    );

    return (
        <Card bgColor="bg-oat" topGradientBorder>
            <div className="flex flex-col gap-15 md:flex-row">
                <div className="flex w-full flex-grow flex-col items-center justify-center text-center md:items-start md:gap-15 md:text-left">
                    <div className="flex flex-col gap-15">
                        <div>
                            <h3 className="text-heading-xs pb-5 font-grotesk-bold">{heading}</h3>
                            {isTrialAvailable && (
                                <Tag bgColor="plusMembership">
                                    <div className="text-body-desktop-xs uppercase">
                                        Try it free for {trialLengthDays} days
                                    </div>
                                </Tag>
                            )}
                        </div>
                        <p>
                            {paused
                                ? 'Resume your Grocery Subscription above to get started.'
                                : 'Want to save even more when you shop? Sign up to enjoy members-only deals, save on shipping fees, and fight hunger with every order.'}
                        </p>
                    </div>
                    {!paused && !mobile && ctaComponent}
                </div>
                <div className="w-full flex-grow">
                    <div className="flex flex-col gap-15">
                        <h6 className="text-body-sm font-grotesk-bold">Members-only benefits</h6>
                        <BenefitsList />
                    </div>
                </div>
                {!paused && mobile && ctaComponent}
            </div>
            <JoinModal
                open={isJoinMembershipModalOpen}
                onClose={() => {
                    setIsJoinMembershipModalOpen(false);
                }}
            />
        </Card>
    );
}

JoinCard.propTypes = {
    paused: PropTypes.bool,
};

JoinCard.defaultProps = {
    paused: false,
};
